// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"42813018","184":"5ce571ca","344":"c8c30f8d","562":"af0d3ccd","655":"b7082eae","693":"b6689953","923":"954496e4","934":"d7e89ea2","939":"b97c8401","990":"2e2517d8"}[chunkId] + ".chunk.js";
};